import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent, createCommentVNode as _createCommentVNode, vShow as _vShow, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3dd5f546"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "export-view" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-icon_bilichi-02" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-icon_zhibeizhen" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-a-Graticules1" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-a-icon_eagle1" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-Format" }, null, -1))
const _hoisted_7 = { id: "export-preview" }
const _hoisted_8 = { class: "main-content" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = { style: {"margin":"0 -12px 0 -12px","padding":"12px 12px 0 12px","border-top":"1px solid #ebebeb","display":"flex","flex-direction":"row"} }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-style":"italic"} }, "I", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"text-decoration":"underline"} }, "U", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "map-preview" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "map-preview-body" }, [
        /*#__PURE__*/_createElementVNode("div", {
          id: "map",
          style: {"height":"100%","width":"100%"}
        })
      ])
    ])
  ])
], -1))
const _hoisted_14 = { class: "aside-content" }
const _hoisted_15 = { id: "mini-map" }
const _hoisted_16 = ["placeholder"]
const _hoisted_17 = { style: {"margin":"0 -12px 0 -12px","padding":"12px 12px 0 12px","border-top":"1px solid #ebebeb","display":"flex","flex-direction":"row"} }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-style":"italic"} }, "I", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"text-decoration":"underline"} }, "U", -1))
const _hoisted_20 = {
  key: 1,
  class: "author-info"
}
const _hoisted_21 = { class: "secondary-text map-by" }

import { computed, reactive } from 'vue';
import { useStore } from 'vuex';

import useExportForm from '@/composables/useExportForm';
import ExtentBoundary from '@/components/ExtentBoundary.vue';
import LayerLegend from '@/components/LayerLegend.vue';
import ImageLegend from '@/components/ImageLegend.vue';
import useExportMap from '@/composables/useExportMap';
import useMiniMap from '@/composables/useMiniMap';
import { checkShowLicense } from "@/store/utils/helper";
import FontButton from './FontButton.vue';
import {
  useTrack,
  FunctionIdEnum,
  EventTypeEnum,
} from '@/components/sendMetrics';


export default /*#__PURE__*/_defineComponent({
  __name: 'ExportView',
  setup(__props, { expose: __expose }) {

const components = {
  LayerLegend,
  ImageLegend,
};

const { track } = useTrack();
const { initExportMap } = useExportMap();
const { initMiniMap } = useMiniMap();

function useStyle() {
  const fonts = [
    {
      label: 'Arial',
      value: 'Arial',
    },
    {
      label: 'Segoe UI',
      value: 'Segoe UI',
    },
    {
      label: 'Roboto',
      value: 'Roboto',
    },
    {
      label: '黑体',
      value: 'simhei',
    },
    {
      label: '宋体',
      value: 'simsun',
    },
    {
      label: '楷体',
      value: 'kaiti',
    },
    {
      label: '仿宋',
      value: 'FangSong',
    },
    {
      label: '微软雅黑',
      value: 'Microsoft YaHei',
    },
  ];
  let style = reactive({
    fontFamily: 'Arial',
    fontSize: '14px',
    color: '#000',
    fontWeight: 'inherit',
    fontStyle: 'inherit',
    textDecoration: 'inherit',
  });

  return {
    fonts,
    style,
  };
}
const { fonts, style: mapTitleStyle } = useStyle();
const { style: mapDescriptionStyle } = useStyle();

const {
  submitting,
  formData,
  scaleOptions,
  formatOptions,
  onScaleChange,
  updateFormData,
  submitFormData,
  onSwitchNorthChange,
  onSwitchGridChange,
  onSwitchMiniMapChange,
  onExportFormatChange,
} = useExportForm();

const store = useStore();

const onSubmit = () => {
  submitFormData();

  const form = store.state.exportStore.formData;

  track(FunctionIdEnum.globalLayer_export_exportMap, EventTypeEnum.CLICK, {
    showNorth: form.switchNorth,
    showMiniMap: form.switchMiniMap,
    showGratiules: form.switchGrid,
    selectExportFormat: form.format,
  });
};

const firstsLegend = computed(() => {
  return store.getters['maps/mapsLegends'][0];
});

const authorName = computed(() => {
  const map = store.getters['maps/topVisibleMap'];
  return map?.author;
});

let description = computed({
  get() {
    return store.state.exportStore.formData.description;
  },
  set(v) {
    updateFormData('description', v);
  }
});

if (firstsLegend.value && checkShowLicense(firstsLegend.value)) {
  description.value = 'The Deep-time Digital Earth (DDE) has launched  for "1:5M World Geological Map and Database Construction." with the support of the Commission for the Geological Map of the World (CGMW), the International Union of Geological Sciences (IUGS) and the Chinese Academy of Geological Sciences (CAGS). We are constructing an entirely seamless, harmonized and unified Geological Map of the World along with its comprehensive database.';
}

__expose({
  initExportMap,
  initMiniMap,
});

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_color_picker = _resolveComponent("el-color-picker")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      "label-position": "left",
      inline: true,
      modelValue: _unref(formData),
      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_isRef(formData) ? (formData).value = $event : null))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, { label: "" }, {
          default: _withCtx(() => [
            _createVNode(ExtentBoundary)
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          label: _withCtx(() => [
            _hoisted_2,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('level')), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _unref(formData).scale,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formData).scale) = $event)),
              placeholder: _ctx.$t('level_select'),
              onChange: _unref(onScaleChange),
              style: {"width":"60px"}
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(scaleOptions), (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder", "onChange"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          label: _withCtx(() => [
            _hoisted_3,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('ExportDrawer.northarrow')), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              modelValue: _unref(formData).switchNorth,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(formData).switchNorth) = $event)),
              "inline-prompt": "",
              "active-text": _ctx.$t('ExportDrawer.sliding1.yes'),
              "inactive-text": _ctx.$t('ExportDrawer.sliding1.no'),
              onChange: _unref(onSwitchNorthChange)
            }, null, 8, ["modelValue", "active-text", "inactive-text", "onChange"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          label: _withCtx(() => [
            _hoisted_4,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('ExportDrawer.gratiules')), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              modelValue: _unref(formData).switchGrid,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(formData).switchGrid) = $event)),
              "inline-prompt": "",
              "active-text": _ctx.$t('ExportDrawer.sliding2.show'),
              "inactive-text": _ctx.$t('ExportDrawer.sliding2.hide'),
              onChange: _unref(onSwitchGridChange)
            }, null, 8, ["modelValue", "active-text", "inactive-text", "onChange"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          label: _withCtx(() => [
            _hoisted_5,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('ExportDrawer.overviewmap')), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              modelValue: _unref(formData).switchMiniMap,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(formData).switchMiniMap) = $event)),
              "inline-prompt": "",
              "active-text": _ctx.$t('ExportDrawer.sliding2.show'),
              "inactive-text": _ctx.$t('ExportDrawer.sliding2.hide'),
              onChange: _unref(onSwitchMiniMapChange)
            }, null, 8, ["modelValue", "active-text", "inactive-text", "onChange"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          label: _withCtx(() => [
            _hoisted_6,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('ExportDrawer.format.title')), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              class: "export-select",
              modelValue: _unref(formData).format,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(formData).format) = $event)),
              placeholder: "Select Format",
              onChange: _unref(onExportFormatChange)
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(formatOptions), (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "onChange"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              loading: _unref(submitting),
              disabled: _unref(submitting),
              onClick: onSubmit,
              icon: "download"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('ExportDrawer.title')), 1)
              ]),
              _: 1
            }, 8, ["loading", "disabled"])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_el_container, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_main, { class: "preview-main" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_el_popover, {
                      trigger: "click",
                      title: "Font Style Setting",
                      width: 400,
                      "trigger-keys": ['enter']
                    }, {
                      reference: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          class: "map-title",
                          placeholder: _ctx.$t('ExportDrawer.maptitle'),
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(formData).title) = $event)),
                          style: _normalizeStyle(_unref(mapTitleStyle))
                        }, null, 12, _hoisted_9), [
                          [_vModelText, _unref(formData).title]
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_10, [
                          _createVNode(_component_el_select, {
                            modelValue: _unref(mapTitleStyle).fontFamily,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(mapTitleStyle).fontFamily) = $event)),
                            teleported: false,
                            style: {"width":"120px"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(fonts), (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode(_component_el_select, {
                            modelValue: _unref(mapTitleStyle).fontSize,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(mapTitleStyle).fontSize) = $event)),
                            teleported: false,
                            style: {"width":"80px","margin":"0 10px"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList([14, 16, 18, 20, 22, 24], (item) => {
                                return _createVNode(_component_el_option, {
                                  key: item,
                                  label: item + 'px',
                                  value: item + 'px'
                                }, null, 8, ["label", "value"])
                              }), 64))
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode(_component_el_color_picker, {
                            modelValue: _unref(mapTitleStyle).color,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(mapTitleStyle).color) = $event)),
                            teleported: false
                          }, null, 8, ["modelValue"]),
                          _createVNode(FontButton, {
                            "checked-value": "bold !important",
                            modelValue: _unref(mapTitleStyle).fontWeight,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(mapTitleStyle).fontWeight) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("B")
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode(FontButton, {
                            "checked-value": "italic !important",
                            modelValue: _unref(mapTitleStyle).fontStyle,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(mapTitleStyle).fontStyle) = $event))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_11
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode(FontButton, {
                            "checked-value": "underline",
                            modelValue: _unref(mapTitleStyle).textDecoration,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(mapTitleStyle).textDecoration) = $event))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_12
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ])
                      ]),
                      _: 1
                    }),
                    _hoisted_13
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_aside, {
                width: "400px",
                style: {"overflow":"visible"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_14, [
                    (firstsLegend.value)
                      ? (_openBlock(), _createBlock(_resolveDynamicComponent(components[firstsLegend.value.type]), {
                          key: 0,
                          url: firstsLegend.value.url,
                          "show-title": true
                        }, null, 8, ["url"]))
                      : _createCommentVNode("", true),
                    _withDirectives(_createElementVNode("div", _hoisted_15, null, 512), [
                      [_vShow, _unref(formData).switchMiniMap]
                    ]),
                    _createVNode(_component_el_popover, {
                      title: "Font Style Setting",
                      trigger: "click",
                      width: 400,
                      "trigger-keys": ['enter']
                    }, {
                      reference: _withCtx(() => [
                        _withDirectives(_createElementVNode("textarea", {
                          placeholder: _ctx.$t('ExportDrawer.discription'),
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_isRef(description) ? (description).value = $event : description = $event)),
                          style: _normalizeStyle(_unref(mapDescriptionStyle)),
                          rows: "6",
                          class: "map-description"
                        }, null, 12, _hoisted_16), [
                          [_vModelText, _unref(description)]
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_17, [
                          _createVNode(_component_el_select, {
                            modelValue: _unref(mapDescriptionStyle).fontFamily,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(mapDescriptionStyle).fontFamily) = $event)),
                            teleported: false,
                            style: {"width":"120px"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(fonts), (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode(_component_el_select, {
                            modelValue: _unref(mapDescriptionStyle).fontSize,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(mapDescriptionStyle).fontSize) = $event)),
                            teleported: false,
                            style: {"width":"80px","margin":"0 10px"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList([14, 16, 18, 20, 22, 24], (item) => {
                                return _createVNode(_component_el_option, {
                                  key: item,
                                  label: item + 'px',
                                  value: item + 'px'
                                }, null, 8, ["label", "value"])
                              }), 64))
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode(_component_el_color_picker, {
                            modelValue: _unref(mapDescriptionStyle).color,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(mapDescriptionStyle).color) = $event)),
                            teleported: false
                          }, null, 8, ["modelValue"]),
                          _createVNode(FontButton, {
                            "checked-value": "bold !important",
                            modelValue: _unref(mapDescriptionStyle).fontWeight,
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(mapDescriptionStyle).fontWeight) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("B")
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode(FontButton, {
                            "checked-value": "italic !important",
                            modelValue: _unref(mapDescriptionStyle).fontStyle,
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(mapDescriptionStyle).fontStyle) = $event))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_18
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode(FontButton, {
                            "checked-value": "underline",
                            modelValue: _unref(mapDescriptionStyle).textDecoration,
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(mapDescriptionStyle).textDecoration) = $event))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_19
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ])
                      ]),
                      _: 1
                    }),
                    (authorName.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          _createVNode(_component_el_text, {
                            size: "small",
                            truncated: ""
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_21, [
                                _createTextVNode("Map by "),
                                _createElementVNode("b", null, _toDisplayString(authorName.value), 1)
                              ])
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})